<template>
  <div class="align">
    <div class="lottie">
      <lottie-animation
        path="generic-loader.json"
        :height="80"
        :width="80"
        :loop="true"
        :auto-play="true"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.align {
  display: flex;
  align-items: center;
  min-height: 24em;
  justify-content: center;
}

.align .lottie {
  flex: 1;
}
</style>
